:host {
  display: block;
  width: 100%;
}

button {
  outline: none;
  border: none;
  border-left: 1px solid var(--default-color-border-layer-primary);
  width: 2.5rem;
  height: 2.5rem;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

button:disabled {
  background-color: transparent;
  cursor: not-allowed;
}

button:focus:enabled {
  border: solid 1.5px var(--color-button-primary);
}

button:hover:enabled {
  background-color: #deddde;
}

.buttons {
  display: flex;
  justify-content: center;
  align-items: center;
}

.message {
  padding-left: var(--default-spacing-06);
  font-family: (var--type-sans);
  font-size: var(--type-scale-14);
  font-weight: var(--type-weight-light);
}

.container {
  border-top: 1px solid var(--default-color-border-layer-primary);
  background-color: #f5f5f4;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}